import { useTranslation } from 'react-i18next';
import './CostBadge.css';

type Props = {
  cost: number;
};

/**
 * Little coin-styled badge showing a token cost. Positions itself at the
 * top-right of a relatively-positioned parent (e.g. a CTA button).
 */
export function CostBadge({ cost }: Props) {
  const { t } = useTranslation();
  return (
    <span
      className="cost-badge"
      aria-label={t('common.tokens', { count: cost })}
    >
      {cost}
    </span>
  );
}
